import { ApolloLink } from '@apollo/client'
import moment from 'moment'
import SessionStorage from '../../util/sessionstore'

const session = new SessionStorage()

const getContext = (headers) => {
  let profile = session.getProfile()
  const token = profile?.token
  return {
    headers: {
      'x-authorization': 'Bearer ' + token,
      start: moment(),
      ...headers,
    },
  }
}

const authLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers }) => getContext(headers))
  return forward(operation)
})

export default authLink
